import * as Sentry from '@sentry/react';

declare global {
  interface Window {
    Appcues?: {
      identify: (userId: string, properties?: Record<string, unknown>) => void;
      group: (groupId: string, properties?: Record<string, unknown>) => void;
      page: () => void;
      reset: () => void;
    };
    AppcuesSettings?: {
      enableURLDetection: boolean;
    };
  }
}

export interface AppcuesUserProperties extends Record<string, unknown> {
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  organizationId: number;
}

export interface AppcuesGroupProperties extends Record<string, unknown> {
  organizationId: number;
}

export function isAppcuesAvailable(): boolean {
  return typeof window !== 'undefined' && typeof window.Appcues !== 'undefined';
}

export function identifyAppcuesUser(
  userId: string,
  properties: AppcuesUserProperties,
): void {
  try {
    if (!isAppcuesAvailable()) {
      console.warn('Appcues is not available');
      return;
    }

    window.Appcues!.identify(userId, properties);
  } catch (error) {
    Sentry.captureException(error, {
      tags: { service: 'appcues', operation: 'identify_user' },
      extra: { userId, properties },
    });
  }
}

export function identifyAppcuesGroup(
  groupId: string,
  properties: AppcuesGroupProperties,
): void {
  try {
    if (!isAppcuesAvailable()) {
      console.warn('Appcues is not available');
      return;
    }

    window.Appcues!.group(groupId, properties);
  } catch (error) {
    Sentry.captureException(error, {
      tags: { service: 'appcues', operation: 'identify_group' },
      extra: { groupId, properties },
    });
  }
}

export function resetAppcuesUser(): void {
  try {
    if (!isAppcuesAvailable()) {
      console.warn('Appcues is not available');
      return;
    }

    window.Appcues!.reset();
  } catch (error) {
    Sentry.captureException(error, {
      tags: { service: 'appcues', operation: 'reset_user' },
    });
  }
}
